module.exports = __webpack_public_path__ + "static/media/oxygen7-logo.96e5146c.png";